var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import TypographyStyle from './TypographyStyle';
import { deprecatedWarning } from '../../utils';
const Typography = (_a) => {
    var { children } = _a, otherProps = __rest(_a, ["children"]);
    if (otherProps.color) {
        deprecatedWarning('You are using the deprecated `color` prop in the `Typography` component. Please use your own custom style rules');
    }
    return React.createElement(TypographyStyle, Object.assign({}, otherProps), children);
};
export default Typography;
//# sourceMappingURL=Typography.js.map